<template>
  <div class="home-slide-show-feature">
    <div class="slideshow-feature">
      <div
        class="slide-feature"
        v-for="(slide, index) in slides"
        :key="index"
        :class="{ active: index === currentSlide }"
      >
        <div class="banner">
          <a href="/menu">
            <img :src="slide.image_url" class="center" alt="Slides Image" />
          </a>
          <div class="banner-div">
            <span class="prev" @click="prevSlide()">
              <img src="@/assets/icons/LeftButton.svg" />
            </span>
            <span class="next" @click="nextSlide()">
              <img src="@/assets/icons/RightButton.svg" />
            </span>
          </div>
        </div>

        <div class="slide-feature-pagination">
          <div class="page-dot">
            <div
              class="slideshow-feature-pagination-dot"
              v-for="(slide, index) in slides"
              :key="index"
              :class="{ active: index === activeIndex }"
              @click="setActive(index)"
            ></div>
          </div>
          <!-- <div class="caption-div">{{ slide.name }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import titleMixin from "@/mixins/TitleMixins.js";
import axios from "axios";

export default {
  name: "slide-show-feature",
  mixins: [titleMixin],

  data() {
    return {
      // slides: [
      //   {
      //     url: require("@/assets/slides/image-slide1.png"),
      //     caption: "Caramel Cream Cheese Pie",
      //   },
      //   {
      //     url: require("@/assets/slides/image-slide1.png"),
      //     caption: "Caramel Cheese Pie",
      //   },
      // ],
      slides: [],
      currentSlide: 0,
      slideInterval: null,
      activeIndex: 0,
    };
  },

  mounted() {
    this.loadBanners();
    this.startSlideshow();
  },

  methods: {
    setActive(index) {
      this.activeIndex = index;
      this.currentSlide = index;
    },

    startSlideshow() {
      this.slideInterval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.activeIndex = this.currentSlide;
      }, 5000);
    },

    stopSlideshow() {
      clearInterval(this.slideInterval);
    },

    prevSlide() {
      this.stopSlideshow();
      this.currentSlide =
        (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.activeIndex = this.currentSlide;
    },

    nextSlide() {
      this.stopSlideshow();
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      this.activeIndex = this.currentSlide;
    },

    loadBanners() {
      let preview = this.$route.query.preview ? this.$route.query.preview : 0;
      axios.get("/banners/products/main?preview=" + preview).then((response) => {
        this.slides = response.data.data;
      });
    },
  },

  beforeUnmount() {
    clearInterval(this.slideInterval);
  },
};
</script>



<style>
.home-slide-show-feature {
  width: 100%;
  position: relative;
  overflow: hidden;
  text-align: center;
  display: flex;
  align-content: center;
}

.home-slide-show-feature .banner {
  background: white url("@/assets/images/faded_mcd.svg") no-repeat center 15px;
  background-size: contain;
  height: 80%;
}

.slideshow-feature {
  position: relative;
  height: 800px;
  width: 100%;
  overflow: hidden;
  align-self: center;
  margin: auto;
}

.slide-feature {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s;
}

.slide-feature.active {
  opacity: 1;
}
.slide-feature img {
  width: 60%;
  height: 100%;
  object-fit: contain;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.controls {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
.controls button {
  background-color: #fff;
  color: #000;
  border: none;
  padding: 10px;
  margin: 0 10px;
  cursor: pointer;
}
.slide-feature-pagination {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.slideshow-feature-pagination-dot {
  width: 40px;
  height: 10px;
  border-radius: 50px;
  margin: 20px 5px;
  background-color: rgba(204, 200, 200, 0.5);
  transition: background-color 0.3s;
  cursor: pointer;
  align-self: center;
  display: flex;
  flex-direction: row;
}

.slideshow-feature-pagination-dot.active {
  background-color: #ffbc0d;
}

.page-dot {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.prev,
.next {
  position: absolute;
  top: 50%;
  height: 60px;
  border: none;
  border-radius: 50%;
  margin-top: -25px;
  cursor: pointer;
  line-height: 48px;
  text-align: center;
  text-indent: -2px;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  font-size: 50px;
}

.prev {
  left: 10%;
}

.next {
  right: 0;
  margin-left: auto;
  margin-right: 10%;
  text-indent: 2px;
}

@media only screen and (max-width: 550px) {
  .slide-feature img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .slideshow-feature {
    position: relative;
    height: 400px;
    width: 100%;
    overflow: hidden;
    align-self: center;
    margin: auto;
  }

  .banner-div {
    width: 100%;
  }

  .prev,
  .next {
    position: absolute;
    top: 50%;
    height: 50px;
    border: none;
    margin-top: -25px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    text-indent: -2px;
    font-size: 50px;
    display: none;
  }

  .next {
    right: 0;
    margin-left: auto;
    margin-right: 10%;
    text-indent: 2px;
  }
}

.banner-div {
  max-width: 300px;
}

.caption-div {
  font-size: 3vw;
  color: black;
  text-align: center;
  font-weight: bold;
  padding: auto;
}
</style>
  